import { ArrowUpRight } from 'lucide-react';

interface Props {
  onContact: () => void;
}

export function LandingNav({ onContact }: Props) {
  const build = new Date().toISOString().slice(2, 10).replace(/-/g, '');

  return (
    <nav className="landing-nav" aria-label="Landing page">
      <div className="brand-block">
        <div className="mark">CE</div>
        <span className="name">
          <span className="brand-text">CDVI</span> Edge
        </span>
      </div>
      <span className="meta">
        <span className="ok">live</span>
        <span className="sep">/</span>
        ATRIUM command cloud
        <span className="sep">/</span>
        build {build}
      </span>
      <div className="spacer" />
      <button className="btn-ghost nav-demo" onClick={onContact}>
        Book demo
      </button>
      <a href="/handler/sign-in">
        <button className="btn-primary nav-sign-in">
          Sign in <ArrowUpRight size={14} />
        </button>
      </a>
    </nav>
  );
}
